import { render } from "./ServicesFourPage.vue?vue&type=template&id=cad9dba0"
import script from "./ServicesFourPage.vue?vue&type=script&lang=js"
export * from "./ServicesFourPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__